// extracted by mini-css-extract-plugin
export default {"tagContainer":"tagContainer__M2NhM","tagText":"tagText__ODM5N","icon":"icon__OTFmN"};